import { render } from "./packageManagement.vue?vue&type=template&id=2ab3f0f2&scoped=true"
import script from "./packageManagement.vue?vue&type=script&lang=js"
export * from "./packageManagement.vue?vue&type=script&lang=js"

import "./packageManagement.vue?vue&type=style&index=0&id=2ab3f0f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ab3f0f2"

export default script